import {useLocation, useParams} from 'react-router-dom'
import { useDeleteSalesPromo, useSalesPromoDetailGeneralInfo } from '../../../providers/SalesPromo.provider';

export function useSalesPromoDetailTabDetail() {
  const location = useLocation()
  const params = useParams<{ id: string }>();
  const generalInfo = useSalesPromoDetailGeneralInfo(params.id, true)
  const deleteSalesPromo = useDeleteSalesPromo()

  return {
    generalInfo,
    location,
    deleteSalesPromo
  }
}
